import axios from "axios";

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "/api" // calls same-origin at /api
      : "http://localhost:5010/api", // local dev
});

export default instance;
